import React, { useEffect, useState } from 'react';
import { BaseConfig } from '../BaseConfig';
import TalksActionsButtons from '../helpers/TalksActionsButtons';
import { UIProperties } from '../UIProperties';
import GeneralButton from '../helpers/GeneralButton';

import './TalksActionsUI.css'
import { playSound, setFocus } from '../../misc/tools';

const TalksActionsUI = (props: UIProperties<TalksActionsUIConfig>) => {
	const [hasInitialized, setHasInitialized] = useState(false);
    var timeout: any = undefined;
	(props.parameters as any).updateVisibility = (isVisible: boolean, onDone: () => void) => {
		setTimeout(() => {
			var el = document.getElementById(props.id);
			if(!el) {
				return;
			}
			playSound('./assets/audio/Menu_Slide');

			el.classList.remove('ta-container-animation');
			el.classList.remove('ta-container-animation-reverse');

			if(isVisible) {
				console.log('showing ' + props.id);
				el.classList.add('ta-container-animation');
			} else { 
				console.log('removing ' + props.id);
				el.classList.add('ta-container-animation-reverse');
			}
			
			setTimeout(() => {
				(window as any)[props.id + 'animation'] = undefined;
				onDone();
			}, 500);
		}, 0);
	}
	useEffect(() => {
        if(!hasInitialized && !timeout) {
            timeout = setTimeout(() => {
                setHasInitialized(true);
            }, 200);
        }
    }, [])
	return (
		<div id={props.id} className="ta-container ta-container-animation modal-disable-select" >
			<p className="ta-header-item" id='first-object-taui' tabIndex={0}>{props.parameters.toptitle}</p>
			<img src="./assets/images/general/components/talks-actions/window_side_large_blank.png"/>
			<div>
				<div className="ta-limit" style={{
					position: 'absolute',
					top: '60px',
					left: hasInitialized ? '0px' : '1230px',
					width: '660px',
					height: '814px',
					overflow: 'auto',
					pointerEvents: 'all'
				}}>
				{props.parameters.talks.map((item: TalksActionsUITalksConfig, index: number) => {
					return (
						<div>
							<TalksActionsButtons parameters= {{
								top: (20 + (120 * index)) + 'px',
								//top: item.toppx,
								text: item.titletext,
								highlightOnHover: true,
								isDisabled: () => item.disable(),
								onClickedd: () => {
									var el = document.getElementById(props.id);
									el.classList.remove('ta-container-animation');
									el.classList.add('ta-container-animation-reverse');
									if(!item.onClicked) {
										playSound('./assets/audio/Menu_Slide');
									}
									setTimeout(() => {

										if(item.onClicked) {
											playSound('./assets/audio/Menu_Slide');
											item.onClicked();
										}
									setFocus('first-object-transform');
								}, 500);
								}
							}}/>
						</div>
					);
				})}
				</div>

				<GeneralButton parameters= {{
					ariaLbl:'Close',
					id: 'last-object-taui',
					srcIdle: './assets/images/general/components/talks-actions/button_close_main.png',
					srcHighlight: './assets/images/general/components/talks-actions/button_close_down.png',
					top: '880px',
					left: '240px',
					width: '200px',
					highlightOnHover: true,
					onClicked: () => {
						var el = document.getElementById(props.id);
						el.classList.remove('ta-container-animation');
						el.classList.add('ta-container-animation-reverse');
						if(!props.parameters.onClosed) {
							playSound('./assets/audio/Menu_Slide');
						}
						setTimeout(() => {
							if(props.parameters.onClosed) {
								playSound('./assets/audio/Menu_Slide');
								props.parameters.onClosed();
							}
						}, 500);
					}
				}}/> 
			</div>
		</div>
	);

};

export interface TalksActionsUIConfig extends BaseConfig {
	toptitle: string;
	onClosed: () => void;
	talks: TalksActionsUITalksConfig[];
	actions: TalksActionsUIActionsConfig[];
}


export interface TalksActionsUITalksConfig {
	toppx: string;
	titletext: string;
	onClicked: () => void;
	disable?: () => boolean;
}

export interface TalksActionsUIActionsConfig {
	menu: string;
	items: string;
}

export default TalksActionsUI;